module.exports = __webpack_public_path__ + "static/media/empty-worksheet-navigator.b54a5c75.svg";